import { render } from "./PCVistaVolcarUL.vue?vue&type=template&id=63aa7a90"
import script from "./PCVistaVolcarUL.vue?vue&type=script&lang=js"
export * from "./PCVistaVolcarUL.vue?vue&type=script&lang=js"

import "./PCVistaVolcarUL.vue?vue&type=style&index=0&id=63aa7a90&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__